import { ReactComponent as DirectIcon } from "assets/icons/direct.svg";
import { ReactComponent as StarIcon } from "assets/icons/star.svg";
import { ReactComponent as SwapIcon } from "assets/icons/swap.svg";
import { ReactComponent as AirdropIcon } from "assets/icons/airdrop.svg";
import { ROUTES } from "consts";

interface NavigationItemProps {
  route: string;
  icon: React.ReactNode;
  label: string;
}

const navigationItems: NavigationItemProps[] = [
  {
    route: ROUTES.explorer,
    icon: <StarIcon width={32} height={32} />,
    label: "Leaderboard",
  },
  {
    route: ROUTES.trade,
    icon: <SwapIcon width={32} height={32} />,
    label: "Trade",
  },
  {
    route: ROUTES.portfolio,
    icon: <DirectIcon width={32} height={32} />,
    label: "Portfolio",
  },
  {
    route: ROUTES.airdrop,
    icon: <AirdropIcon width={32} height={32} />,
    label: "Airdrop",
  },
];

interface PageInfo {
  pageType: "main" | "sub";
  defaultPreviousRoute?: string;
}
const pageTypeMap: Record<(typeof ROUTES)[keyof typeof ROUTES], PageInfo> = {
  [ROUTES.explorer]: { pageType: "main" },
  [ROUTES.cabalId]: { pageType: "sub", defaultPreviousRoute: ROUTES.explorer },
  [ROUTES.portfolio]: { pageType: "main" },
  [ROUTES.referral]: { pageType: "sub", defaultPreviousRoute: ROUTES.portfolio },
  [ROUTES.tokenId]: { pageType: "sub", defaultPreviousRoute: ROUTES.trade },
  [ROUTES.trade]: { pageType: "main" },
  [ROUTES.airdrop]: { pageType: "main" },
  [ROUTES.airdropGroup]: { pageType: "main" },
  [ROUTES.redirect]: { pageType: "main" },
  // [ROUTES.cabal]: "main",
  // [ROUTES.gated]: "sub",
  // [ROUTES.deployer]: "main",
  // [ROUTES.profile]: "main",
  // [ROUTES.faq]: "main",
  // [ROUTES.onboarding]: "sub",
  // [ROUTES.quest]: "sub",
  // [ROUTES.call]: "sub",
  // [ROUTES.create]: "sub",
  // [ROUTES.design]: "main",
  // [ROUTES.layout]: "main",
};

export { navigationItems, type NavigationItemProps, pageTypeMap };
